// Types
import Portfolio from '@/types/portfolio';

// Utils
import { HOLDING_TYPES } from '../portfolios';
import Alt from '@/types/models/alt';
import { sumHoldingValues, weightedAverage } from '../calculation-utils';
import PortfolioAltMetrics from '@/types/portfolio-alt-metrics';

/**
 * Aggregates alt metrics fields using weighted average calculations
 * @param portfolio The portfolio containing alt holdings
 * @param alts Array of alternative investments data
 * @returns Aggregated alt metrics
 */
export const calculateAltMetrics = (portfolio: Portfolio, alts: Alt[]): PortfolioAltMetrics | null => {
  if (!portfolio.holdings.length) return null;

  const areAllAlts = portfolio.holdings.every(h => h.original.type === HOLDING_TYPES.ALT);
  if (!areAllAlts) return null;

  return {
    called: sumHoldingValues(portfolio, alts, 'called'),
    commitment: {
      size: sumHoldingValues(portfolio, alts, 'commitment.size'),
    },
    distributed: sumHoldingValues(portfolio, alts, 'distributed'),
    carriedInterest: {
      rate: weightedAverage(portfolio, alts, 'carriedInterest.rate'),
    },
    fundFormationCost: weightedAverage(portfolio, alts, 'fundFormationCost'),
    managementFee: {
      investPeriod: weightedAverage(portfolio, alts, 'managementFee.investPeriod'),
      postInvestPeriod: weightedAverage(portfolio, alts, 'managementFee.postInvestPeriod'),
    },
    medianBenchmarkNetIrr: weightedAverage(portfolio, alts, 'medianBenchmarkNetIrr'),
    netIrr: weightedAverage(portfolio, alts, 'netIrr'),
    remaining: sumHoldingValues(portfolio, alts, 'remaining'),
  };
};
